<template>
  <div>
    <div v-if="userInfo" style="margin:1%">
      <b-form-group label-align="right" :label="$t('Profile of documents')" label-cols="4" label-cols-xl="2" label-cols-md="4">
        <b-form-select :options="listOfDocuments" v-model="userInfo.doc_profile_id"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Router')" label-cols="4" label-cols-xl="2" label-cols-md="4">
        <b-form-select :options="listOfRouiers" v-model="userInfo.router_id"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Port')" label-cols="4" label-cols-xl="2" label-cols-md="4">
        <b-form-input type="number" v-model="userInfo.port_number"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Currency')" label-cols="4" label-cols-xl="2" label-cols-md="4">
        <b-form-select v-model="userInfo.binded_currency_id" :options="listOfCurrencies"/>
      </b-form-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentRow: null,
    userInfo: null
  },
  computed: {
    listOfCurrencies () {
      let tmp = []
      for (let el of this.$store.getters['ReferenceBooks/CURRENCIES']) {
        let newEl = {
          value: el.currency_id,
          text: el.currency_brief_name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    listOfRouiers () {
      let tmp = []
      for (let el of this.$store.getters['Settings/FIREWALLS']) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    listOfDocuments () {
      let tmp = []
      for (let el of this.$store.getters['Settings/PROFILES_OF_DOCUMENTS']) {
        let newEl = {
          value: el.profile_id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/others/main.vue